import { Modal, Button } from 'react-bootstrap';

export default function ModalAlert({
    show,
    title,
    onConfirm,
    onCancel,
    onConfirmText,
    onCancelText,
    children,
    tamanho = 'md'
}) {
    return (
        <Modal show={show} animation={false} size={tamanho} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
            <Modal.Footer>
                {onCancel && <Button variant="secondary" onClick={onCancel}>{onCancelText}</Button>}
                {onConfirm && <Button variant="primary" onClick={onConfirm}>{onConfirmText}</Button>}
            </Modal.Footer>
        </Modal>
    );
}